<div class="d-flex">
    <div class="map">
        <google-map
            [options]="mapOptions"
            [center]="mapCenter"
            [width]="400"
            height="100%"
            [zoom]="15"
            (mapInitialized)="mapInitialized($event)"
            (mapClick)="onMapClick($event)"
        >
            <map-marker *ngIf="position.value" [position]="position.value" [title]="title.value"></map-marker>
        </google-map>
    </div>

    <div class="settings">
        <web-settings-breadcrumbs>
            <div class="breadcrumb-icon">
                <a (click)="cancelEvent.emit()">
                    <img
                        src="assets/img/websites/lpc-back-icon.svg"
                        class="first-breadcrumb-icon"
                        alt="lpc-back-icon"
                    />
                </a>
            </div>
            <div class="breadcrumb-text">
                <span>{{ "control_map_settings" | translate }}</span>
            </div>
        </web-settings-breadcrumbs>

        <div class="panel-options-body">
            <p class="text-muted">{{ "input_or_pick_address_on_the_map" | translate }}</p>

            <form (submit)="$event.preventDefault()">
                <div class="form-group mb-20" [class.has-error]="invalidAddress">
                    <label>{{ "control_address" | translate }}</label>
                    <div>
                        <input
                            #addressInput
                            class="form-control"
                            type="text"
                            [value]="address.value"
                            [formControl]="address"
                            placeholder=""
                            aria-describedby="helpBlock"
                        />
                        <span id="helpBlock" class="help-block small" *ngIf="invalidAddress">{{
                            "maps_error_select_address_from_dropdown" | translate
                        }}</span>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label>{{ "maps_address_title" | translate }}</label>
                    <div>
                        <input
                            #titleInput
                            type="text"
                            class="form-control"
                            [value]="title.value"
                            [formControl]="title"
                        />
                        <span class="help-block small">{{ "maps_address_title_help_text" | translate }}</span>
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label>{{ "maps_address_description" | translate }}</label>
                    <div>
                        <input class="form-control" [value]="description.value" [formControl]="description" />
                        <span class="help-block small">{{ "maps_short_description" | translate }}</span>
                    </div>
                </div>
            </form>
        </div>

        <web-settings-footer
            (saveEvent)="onSave()"
            (cancelEvent)="onCancel()"
            [isSaveDisabled]="!position.value"
        ></web-settings-footer>
    </div>
</div>
